/*
  Store-specific header behaviour, kept out of the theme's own scripts so it
  survives theme updates and works with the minified theme scripts.
  - Closes open desktop menus when the sticky header appears or disappears.
  - Closes open desktop menus on scroll on touch devices (iPad Safari).
  - Desktop: search sits in the logo row; mobile: search sits in the menu row.
*/
(function () {
  if (window.__customHeaderLoaded) return;
  window.__customHeaderLoaded = true;

  var DESKTOP_MIN = 799;

  function closeAllMenus() {
    var manager = window.navigationDesktopManager;
    if (manager && Array.isArray(manager.desktopNavs)) {
      manager.desktopNavs.forEach(function (nav) {
        if (nav && nav.headerNavMenu && typeof nav.headerNavMenu.closeAllMenus === 'function') {
          nav.headerNavMenu.closeAllMenus();
        }
      });
    }
    document
      .querySelectorAll('.main-nav__wrapper details[open], .sticky_nav details[open]')
      .forEach(function (details) {
        details.removeAttribute('open');
        details.setAttribute('aria-expanded', 'false');
      });
  }

  function applySearchLayout() {
    var mainHeader = document.querySelector('.header-group .header');
    if (!mainHeader) return;

    var logoRowSearch = mainHeader.querySelector('.logo-search-row .search-container');
    var inDesktop = window.innerWidth >= DESKTOP_MIN;

    // The sticky header never shows the logo-row search.
    document.querySelectorAll('.sticky_nav .logo-search-row .search-container').forEach(function (el) {
      el.style.display = 'none';
    });

    if (logoRowSearch) logoRowSearch.style.display = inDesktop ? '' : 'none';
    mainHeader.querySelectorAll('.search-container').forEach(function (el) {
      if (!el.closest('.logo-search-row')) el.style.display = inDesktop ? 'none' : '';
    });
  }

  // The theme adds/removes "sticky_nav--stick" on its sticky header clone.
  function watchSticky(sticky) {
    if (sticky.__customHeaderWatched) return;
    sticky.__customHeaderWatched = true;
    var wasStuck = sticky.classList.contains('sticky_nav--stick');
    new MutationObserver(function () {
      var isStuck = sticky.classList.contains('sticky_nav--stick');
      if (isStuck !== wasStuck) {
        wasStuck = isStuck;
        closeAllMenus();
      }
    }).observe(sticky, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    document.querySelectorAll('.sticky_nav').forEach(watchSticky);
    applySearchLayout();
  }

  // The sticky clone is created by the theme after load (and again when the
  // header is re-rendered in the theme editor), so re-run when the page changes.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      init();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  window.addEventListener('resize', applySearchLayout, { passive: true });
  window.addEventListener('orientationchange', applySearchLayout, { passive: true });

  var isTouch =
    (window.matchMedia &&
      (window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(hover: none)').matches)) ||
    'ontouchstart' in window;

  if (isTouch) {
    var lastCloseAt = 0;
    window.addEventListener(
      'scroll',
      function () {
        var now = Date.now();
        if (now - lastCloseAt > 150) {
          closeAllMenus();
          lastCloseAt = now;
        }
      },
      { passive: true }
    );
  }

  // Essential Loyalty puts its cart box ("+139 points for this order") before
  // the first .checkout_button it finds at load, and keeps it there. The theme
  // has three copies of the mini cart (sticky, mobile, desktop), so keep a
  // single .minicart-checkout wrapper (box + checkout button) and move it into
  // whichever copy is on screen.
  function syncRewardsAnchor() {
    var slots = Array.prototype.slice.call(document.querySelectorAll('.cart-container .minicart-checkout-slot'));
    if (!slots.length) return;
    var wrappers = Array.prototype.slice.call(document.querySelectorAll('.cart-container .minicart-checkout'));
    if (!wrappers.length) return;
    // The app inserts its box inside the wrapper (before .checkout_button), so
    // the wrapper that holds the box is the one to keep; it moves as a unit.
    var keeper = wrappers.filter(function (w) { return w.querySelector('.honeypop-cp'); })[0]
      || wrappers.filter(function (w) { return w.classList.contains('is-keeper'); })[0] || wrappers[0];
    keeper.classList.add('is-keeper');
    wrappers.forEach(function (w) { if (w !== keeper) w.parentNode.removeChild(w); });

    var target = null;
    slots.forEach(function (slot) {
      var rect = slot.closest('.cart-container').getBoundingClientRect();
      var onScreen = rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
      if (onScreen && !target) target = slot;
    });
    if (target && keeper.parentElement !== target) target.appendChild(keeper);
  }
  var anchorPending = false;
  function scheduleAnchorSync() {
    if (anchorPending) return;
    anchorPending = true;
    requestAnimationFrame(function () { anchorPending = false; syncRewardsAnchor(); });
  }
  if (document.querySelector('.minicart-checkout-slot')) {
    syncRewardsAnchor();
    window.addEventListener('scroll', scheduleAnchorSync, { passive: true });
    window.addEventListener('resize', scheduleAnchorSync, { passive: true });
    window.addEventListener('load', scheduleAnchorSync);
    new MutationObserver(scheduleAnchorSync).observe(document.body, { childList: true, subtree: true });
  }
})();

/*
  Product page: the Mailchimp "Notify me when available" button takes the
  place of the greyed-out Sold out button (it is moved into the same row;
  the CSS in custom-mega.css hides Sold out while the Notify button shows).
*/
(function () {
  function moveNotifyButton() {
    var block = document.querySelector('.mailchimp-for-shopify-product-block');
    var slot = document.querySelector('.purchase-details__buttons');
    if (block && slot && !slot.contains(block)) slot.appendChild(block);
  }
  moveNotifyButton();
  document.addEventListener('DOMContentLoaded', moveNotifyButton);
  window.addEventListener('load', moveNotifyButton);
  // Mailchimp can inject its block late: keep checking for 10 seconds on product pages, then stop.
  if (document.querySelector('.purchase-details__buttons')) {
    var tries = 0;
    var t = setInterval(function () {
      moveNotifyButton();
      if (++tries > 20) clearInterval(t);
    }, 500);
  }
})();

/* "Save £80.00" tag next to the price: show whole amounts without ".00" ("Save £80"), also after the
   currency switcher rewrites the amount. Amounts with pence (£80.50) are left as they are. */
(function () {
  function tidy(root) {
    (root || document).querySelectorAll('.sg-save .money').forEach(function (m) {
      var t = m.textContent, n = t.replace(/([.,])00(?=\D*$)/, '');
      if (n !== t) m.textContent = n;
    });
  }
  // Watches only the price boxes on product pages (nothing at all on other pages), so it costs nothing elsewhere.
  function start() {
    var boxes = document.querySelectorAll('.product_section [data-price-ui]');
    if (!boxes.length) return;
    tidy();
    var mo = new MutationObserver(function () { tidy(); });
    boxes.forEach(function (b) { mo.observe(b, { childList: true, subtree: true, characterData: true }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Chat and Rewards links (Oct 2026). The apps' floating buttons are hidden (custom-mega.css); any element with
   data-sg-chat or data-sg-rewards (header chat icon, phone menu, footer, product page) opens the same window
   by pressing the app's own hidden button. Links to #chat / #rewards from elsewhere work too.
   If an app has not loaded yet, it waits a few seconds; if it never loads, chat falls back to email. */
(function () {
  function press(find, fallback, max) {
    var tries = 0;
    (function go() {
      var b = find();
      if (b) { b.click(); return; }
      if (++tries < (max || 30)) { setTimeout(go, 200); return; }
      if (fallback) fallback();
    })();
  }
  /* Speed (15 Oct 2026): the Re:amaze app embed is off, so its chat code (about 210 KB) loads only when someone asks
     for the chat. These are the settings the app embed used to print (account, look, FAQ/orders apps). */
  function loadChat() {
    if (document.getElementById('reamaze-widget') || window.sgChatLoading) return;
    window.sgChatLoading = true;
    var _support = window._support = window._support || { ui: {}, user: {} };
    _support.account = 'shishagear';
    _support.ui.contactMode = 'mixed';
    _support.ui.enableKb = 'true';
    _support.ui.styles = { widgetColor: 'rgb(0, 0, 0)', gradient: true };
    _support.ui.shoutboxFacesMode = 'default';
    _support.ui.shoutboxHeaderLogo = true;
    _support.ui.widget = { icon: 'webChat', displayOn: 'all', fontSize: 'default', allowBotProcessing: true, slug: 'shishagear-chat-slash-contact-form-shoutbox', label: { text: 'Hello!', mode: 'none', delay: 3, duration: 30 }, position: 'bottom-right', size: '58', mobilePosition: 'bottom-right', mobileSize: '58' };
    _support.apps = { recentConversations: {}, faq: { enabled: true }, orders: { enabled: true }, shopper: { enabled: true } };
    _support.ui.appOrder = ['faq', 'orders', 'shopper', 'recentConversations'];
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://cdn.reamaze.com/assets/reamaze-loader.js';
    document.head.appendChild(s);
  }
  function chat() {
    loadChat();
    press(function () { return document.getElementById('reamaze-widget'); },
      function () { location.href = 'mailto:cs@shishagear.com'; }, 75);
  }
  function rewards() {
    press(function () { return document.querySelector('#honeypop-app [class*="LabelLauncher"]'); },
      function () { location.href = '/account'; });
  }
  function closeMenu(el) {
    var d = el.closest('details[data-mobile-menu]');
    if (d && d.open) { var t = d.querySelector('[data-mobile-menu-trigger]'); if (t) t.click(); else d.open = false; }
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-sg-chat]'), r = !c && e.target.closest('[data-sg-rewards]');
    if (!c && !r) return;
    e.preventDefault();
    closeMenu(c || r);
    (c ? chat : rewards)();
  });
  if (location.hash === '#chat') chat();
  if (location.hash === '#rewards') rewards();
})();

/* Phone menu Login row: Shopify's account button only covers the word, so a tap anywhere else on the row
   (including the person icon on the right) presses that button too. */
document.addEventListener('click', function (e) {
  var li = e.target.closest && e.target.closest('#header li.sg-mi--account');
  if (!li || e.target.closest('shopify-account')) return;
  var acct = li.querySelector('shopify-account');
  var btn = acct && acct.shadowRoot && acct.shadowRoot.querySelector('a, button');
  if (btn) btn.click(); else location.href = '/account';
});

/* Phones (17 Oct 2026): the Back button (or a swipe back) closes whatever is open on top of the page (menu,
   basket, search, Browse & Filter panel, photo viewer) instead of leaving the page. Opening one adds a step to the
   browser history; closing it any other way takes that step back off. A link pressed inside an open panel
   replaces the step, so Back from the next page still comes straight back here. */
(function () {
  if (!window.matchMedia || !window.history || !history.pushState) return;
  var phone = window.matchMedia('(max-width: 798px)');
  var STEP = 'sgPanel';
  var pushed = false, skipPop = false, pending = false;

  function visible(el) { var r = el && el.getBoundingClientRect(); return !!(r && r.width > 0 && r.height > 0); }
  function openCart() {
    return Array.prototype.filter.call(document.querySelectorAll('.cart-container.active_link'), function (c) {
      return visible(c.querySelector('.cart_content'));
    })[0];
  }
  function menuOpen() { var d = window.mobileMenuDrawer; return !!(d && d.el && d.animation && d.animation.state === 'open'); }
  function searchOpen() { var m = window.mobileSearch; return !!(m && m.el && m.isClosed && !m.isClosed()); }
  function isOpen() {
    var b = document.body.classList;
    return menuOpen() || searchOpen() || b.contains('sg-filters-open') || b.contains('fancybox-active') || !!openCart();
  }
  function closeAll() {
    if (menuOpen()) window.mobileMenuDrawer.close();
    if (searchOpen()) window.mobileSearch.close();
    document.body.classList.remove('sg-filters-open');
    if (window.jQuery && jQuery.fancybox && document.body.classList.contains('fancybox-active')) jQuery.fancybox.close(true);
    var c = openCart();
    if (c) { var cont = c.querySelector('.cart_content__continue-shopping'); if (cont) cont.click(); else c.classList.remove('active_link'); }
  }
  function sync() {
    pending = false;
    var open = phone.matches && isOpen();
    if (open && !pushed) {
      pushed = true;
      history.pushState({ sgPanel: 1 }, '');
    } else if (!open && pushed) {
      pushed = false;
      if (history.state && history.state[STEP]) { skipPop = true; history.back(); }
    }
  }
  function schedule() { if (!pending) { pending = true; setTimeout(sync, 30); } }

  window.addEventListener('popstate', function () {
    if (skipPop) { skipPop = false; return; }
    if (pushed) { pushed = false; closeAll(); }
  });
  // A link pressed while a panel is open: replace the extra step instead of adding another one.
  window.addEventListener('click', function (e) {
    if (!pushed || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(javascript|mailto|tel|sms):/i.test(href)) return;
    var url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
    e.preventDefault();
    location.replace(url.href);
  });
  // Opened panels show up as class changes (body, basket) or the menu's open attribute.
  new MutationObserver(schedule).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['class', 'open'] });
  // A page kept by the browser and shown again with Back starts with nothing open.
  window.addEventListener('pageshow', function (e) { if (e.persisted) { pushed = false; if (isOpen()) closeAll(); } });
})();

/* Phones: tapping the search icon opens the search box with the keyboard up, ready to type. The focus has to
   happen during the tap itself, or iPhones will not show the keyboard. */
document.addEventListener('click', function (e) {
  var icon = e.target.closest && e.target.closest('[data-dropdown-rel="search"]');
  if (!icon || !window.mobileSearch || !window.matchMedia('(max-width: 798px)').matches) return;
  var box = document.querySelector('[data-mobile-search]');
  var input = box && box.querySelector('input[name="q"]');
  if (!input) return;
  // The box only fades in a moment later; show it now (still see-through) so the box can take the focus.
  box.style.display = 'block';
  input.focus();
  setTimeout(function () { box.style.display = ''; }, 700);
  setTimeout(function () { if (document.activeElement !== input && !window.mobileSearch.isClosed()) input.focus(); }, 350);
});

/* Basket page (17 Oct 2026): after + / − / remove is saved, the page reloads in place: it stays at the same
   spot and does not add a Back step (the theme used to send the form again, which did both).
   Called from assets/app.min.js and app.js.liquid. */
window.sgCartReload = function () {
  try { sessionStorage.setItem('sgCartY', String(window.scrollY || 0)); } catch (e) {}
  location.replace(location.pathname + location.search);
};
(function () {
  var y = null;
  try { y = sessionStorage.getItem('sgCartY'); sessionStorage.removeItem('sgCartY'); } catch (e) {}
  if (y === null || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(location.pathname)) return;
  var go = function () { window.scrollTo(0, +y); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  window.addEventListener('load', go);
})();

/* Phone menu (23 Oct 2026): tapping a menu word that has a branch (Shisha, Flavours, Accessories) opens the branch,
   same as the arrow, instead of going straight to the collection. Each branch starts with its own "All ..." link.
   Charcoal, Base, Bowls and Hoses have no arrow on the phone and go straight to their page, which has the same
   choices as picture buttons (custom-mega.css hides their arrow and branch). The words stay real links, so Google still sees them. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('#mobile_menu li.sublink > a.parent-link--true');
  if (!a || e.target.closest('.icon-down-arrow')) return;
  if (a.matches('#mobile_menu > li > a:is([href$="/collections/charcoal"], [href$="/collections/accessories-all-vases"], [href$="/collections/mmenu-bowls"], [href$="/collections/accessories-shisha-hoses-pipes"])')) return;
  var arrow = a.querySelector('.icon-down-arrow');
  if (!arrow) return;
  e.preventDefault();
  e.stopPropagation();
  arrow.click();
}, true);

/* Notify me (Oct 2026): Mailchimp's back-in-stock pop-up asks for an email even when the customer is signed in.
   Its form sits in an open shadow root (.mcforms-wrapper), so when a signed-in customer presses Notify me the
   email box is filled in for them and they only press the button. Guests see the empty box as before. */
(function () {
  var email = (window.PXUTheme && window.PXUTheme.sgCustomerEmail) || '';
  if (!email) return;
  function fill() {
    var done = false;
    document.querySelectorAll('.mcforms-wrapper').forEach(function (h) {
      var input = h.shadowRoot && h.shadowRoot.querySelector('input[type="email"]');
      if (input && !input.value) {
        Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(input, email);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (input && input.value) done = true;
    });
    return done;
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.back-in-stock-btn')) return;
    var tries = 0;
    (function go() { if (fill() || ++tries > 20) return; setTimeout(go, 150); })();
  });
})();
